import "./style.css";
import React, { useState, useEffect, useCallback } from "react";
import ButtonCom from "../../../components/button/button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";

import { RiDownload2Fill } from "react-icons/ri";
import { AgGridReact } from "ag-grid-react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

import { useDispatch, useSelector } from "react-redux";
import {
  assignEmployeeAuditModelPath,
  deleteAuditModelPath,
  getStaffAuditModelListPath,
} from "../../../services/config";
import {
  fetchAuditModalData,
  saveUpdateDeleteAudit,
  fetchAuditStaffData,
  initAuditState,
} from "../../../redux/slices/auditSlice";
import Widgets from "../../../components/Widgets";
import CustomPagination from "../../../components/CustomPagination";
import { HasPermission } from "../../../services/hasPermission";

const App = () => {
  const [searchParams] = useSearchParams();
  const outletId = searchParams.get("outletId");
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const auditState = useSelector((state) => state.audit);

  const [questionsList, setQuestionsList] = useState([]);
  // Delete record ------------------------
  const [show, setShow] = useState(false);
  const [auditModalId, setAuditModalId] = useState(null);
  const [show1, setShow1] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const isSelectAll =
    selectedUsers.length === employeeList.length && employeeList.length > 0;

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getAuditData = useCallback(() => {
    let data = {
      userId: user.user_id,
      outletId: outletId,
    };
    dispatch(fetchAuditModalData(data));
  }, [outletId]);

  useEffect(() => {
    getAuditData();
  }, []);

  const handleModalClose1 = () => {
    setShow1(false);
    setSelectedUsers([]);
  };

  const handleShow1 = () => setShow1(true);

  const getStaff = (auditId) => {
    setAuditModalId(auditId);
    const path = getStaffAuditModelListPath(user.user_id, auditId);
    console.log(path);
    dispatch(fetchAuditStaffData(path));
  };

  const selectUser = (event, userId) => {
    const isChecked = event.target.checked;
    setSelectedUsers((prevSelected) =>
      isChecked
        ? [...prevSelected, userId]
        : prevSelected.filter((id) => id !== userId)
    );
  };

  const SelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allUserIds = employeeList.map((row) => row.staffId);
      setSelectedUsers(allUserIds);
    } else {
      setSelectedUsers([]);
    }
  };

  const searchEmployees = (val) => {
    setSearchQuery(val);
    const filteredEmployees = filterEmployeeList.filter((v) =>
      v.full_name.toLowerCase().includes(val.toLowerCase())
    );
    setEmployeeList(filteredEmployees);
  };

  const handleAssignShiftSubmit = (e) => {
    e.preventDefault();
    const data = {
      path: assignEmployeeAuditModelPath,
      data: {
        userId: user.user_id,
        staffId: selectedUsers.toString(),
        auditModelId: auditModalId,
      },
    };
    dispatch(saveUpdateDeleteAudit(data));
  };

  const updateQuestionnaire = (data) => {
    localStorage.setItem("questionnaire", JSON.stringify(data));
    navigate("/update-questionnaire");
  };

  const handleModalClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDelete = (id) => {
    setAuditModalId(id);
    handleShow();
  };

  const handleDeleteSubmit = () => {
    const body = {
      path: deleteAuditModelPath,
      data: {
        userId: user.user_id,
        auditModelId: auditModalId,
      },
    };
    dispatch(saveUpdateDeleteAudit(body));
    handleModalClose();
  };

  useEffect(() => {
    if (auditState.auditGetSuccess || auditState.auditGetError) {
      auditState.auditGetSuccess
        ? setQuestionsList(auditState.auditGetData)
        : toast.error(auditState.auditGetMessage);
      console.log(auditState.auditGetData);
      dispatch(initAuditState());
    }

    if (auditState.auditStaffSuccess || auditState.auditStaffError) {
      auditState.auditStaffSuccess
        ? setFilterEmployeeList(auditState.auditStaffData)
        : toast.error(auditState.auditStaffMessage);
      auditState.auditStaffSuccess
        ? setEmployeeList(auditState.auditStaffData)
        : null;

      const selectedUser = auditState.auditStaffData
        .filter((val) => val.auditAssignedStatus == "1")
        .map((row) => row.staffId);
      setSelectedUsers(selectedUser);

      dispatch(initAuditState());
    }

    if (auditState.auditSuccess || auditState.auditError) {
      auditState.auditSuccess
        ? toast.success(auditState.auditMessage)
        : toast.error(auditState.auditMessage);
      dispatch(initAuditState());
      handleModalClose1();
      getAuditData();
    }
  }, [auditState, dispatch]);

  const [showPdf, setShowPdf] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const [auditPdfData, setAuditPdfData] = useState([]);

  const downloadReport = (data) => {
    setAuditPdfData([data]);
    setTimeout(() => {
      setShowPdf(true);
    }, 500);
  };

  const heading = [
    {
      headerName: "Title",
      field: "auditModelName",
      flex: 1,
    },

    {
      headerName: "Action",
      width: 200,
      cellRenderer: (rowData) => {
        return (
          <>
            <div className="Branches-table-button">
              {HasPermission("Audit", "edit") && (
                <PiPencilSimpleLineBold
                  style={{ cursor: "pointer", fontSize: 30}}
                  onClick={() => updateQuestionnaire(rowData.data)}
                  className="edit-icon"
                />
              )}
              {HasPermission("Audit", "delete") && (
                <RiDeleteBinLine className="delete-icon"
                  onClick={() => handleDelete(rowData.data.auditModelId)}
                  style={{ cursor: "pointer", fontSize: 30, color: "red" }}
                />
              )}

              {!HasPermission("Audit", "edit") &&
                !HasPermission("Audit", "delete") &&
                "-"}

              {/* <RiDownload2Fill
                onClick={() => downloadReport(rowData.data)}
                style={{
                  cursor: "pointer",
                  fontSize: 25,
                  color: "#04caf1",
                  marginRight: "10px",
                }}
              /> */}
            </div>
          </>
        );
      },
    },
  ];

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];
  const downloadPDF = () => {
    window.print();
  };
  return (
    <div
      className="form-builders"
      style={{
        position: "fixed",
        width: "calc(100%)",
        height: "calc(100vh - 40px)",
        background: "transparent",
        padding: "0 10px"
      }}
    >
      <Widgets
        icon={
          <div
            style={{
              display: "flex",
              alignItem: "center",
              justifyContent: "start",
              gap: "10px",
            }}
          >
            <Link to={"/audit"}>
              <ArrowBackIcon
                sx={{ scale: 1 }}
                style={{ marginTop: "2px" }}
                className="color-white"
              />
            </Link>
            <span
              style={{
                fontSize: "20px",
                fontWeight: "400",
              }}
              className="color-white"
            >
              Manage Questionnaire
            </span>
          </div>
        }
        button={
          HasPermission("Audit", "create") && (
            <ButtonCom
              type={"link"}
              class_name={"border-radius-8px universal-btn no-underline line_height_15"}
              text="Create Questionnaire"
              url_or_onclick={`/create-questionnaire?outletId=${outletId}`}
              icon={null}
              width={""}
            />
          )
        }
        body={
          <>
            <div
              className="ag-theme-quartz custom-grid mt-2"
              style={{
                height: "calc(100vh - 200px)",
                width: "100%",
                padding: "0 0px",
              }}
            >
              <AgGridReact
                rowData={Array.isArray(questionsList) ? questionsList : []}
                columnDefs={heading}
                omLayout="autoHeight"
                pagination={true}
                paginationPageSize={paginationPageSize}
                onGridReady={onGridReady}
              />
            </div>
            <div className="d-flex align-items-center justify-content-between custom-pagination">
              {gridApi && <CustomPagination gridApi={gridApi} />}
            </div>
          </>
        }
      />

      <Modal show={show} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete Questionnaire</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure! to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "gray",
              color: "#fff", border: "none",
              marginRight: "5px",
            }}
            onClick={handleModalClose}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "red", color: "#fff", border: "none", }}
            onClick={handleDeleteSubmit}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show1} onHide={handleModalClose1} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Assign Employee to this Shift</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
          <input
            className="search-employee"
            type="text"
            placeholder="Search employees..."
            value={searchQuery}
            onChange={(e) => searchEmployees(e.target.value)}
          />
          <table className="audit-tbl">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={isSelectAll}
                    onChange={SelectAll}
                    id="sel-all"
                    className="colored-checkbox"
                  />
                  &nbsp; &nbsp;
                  <label style={{ cursor: "pointer" }} htmlFor="sel-all">
                    Select All
                  </label>
                </th>
                <th>Employee Name</th>
              </tr>
            </thead>
            <tbody>
              {employeeList.length > 0 ? (
                employeeList.map((row) => (
                  <tr key={row.staffId}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedUsers.includes(row.staffId)}
                        onChange={(e) => selectUser(e, row.staffId)}
                        id={"shift" + row.staffId}
                        className="colored-checkbox"
                      />
                    </td>
                    <td
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <label
                        style={{ cursor: "pointer" }}
                        htmlFor={"shift" + row.staffId}
                      >
                        {row.full_name}
                      </label>
                      <span style={{ fontSize: "12px", color: "gray" }}>
                        {row.employee_id}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No employees found</td>
                </tr>
              )}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "#566573",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={handleModalClose1}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "#5dade2", color: "#fff" }}
            onClick={handleAssignShiftSubmit}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      {/* PDF file -------------------- */}
      <Modal show={showPdf} onHide={() => setShowPdf(false)} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Audit Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="report">
            {auditPdfData.length > 0
              ? auditPdfData?.map((audit, index) => (
                <div key={index}>
                  <h3>Audit Model: {audit.auditModelName}</h3>
                  <p>Date: {audit.created_on}</p>
                  <table style={styles.table} className="audit-tbl">
                    <thead>
                      <tr>
                        <th>Question</th>
                        <th>Rating</th>
                        <th>Answer</th>
                        <th>File Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {audit.auditQuestions.map((question, qIndex) => {
                        // const answerData = audit.questionAnswers
                        //   .flatMap((q) => q.answer)
                        //   .find((ans) => ans.labelAnswer === question.label);

                        return (
                          <tr key={qIndex}>
                            <td>{question.label}</td>
                            <td>{question.rating || "N/A"}</td>
                            {/* <td>
                                {answerData
                                  ? answerData.labelAnswer
                                  : "No Answer"}
                              </td>
                              <td>
                                {answerData
                                  ? answerData.fileName || "No File"
                                  : "No File"}
                              </td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ))
              : null}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "gray",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={() => setShowPdf(false)}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "green", color: "#fff" }}
            onClick={downloadPDF}
          >
            Download
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

const styles = {
  button: {
    padding: "10px 20px",
    margin: "10px 0",
    backgroundColor: "blue",
    color: "white",
    border: "none",
    cursor: "pointer",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
    border: "1px solid black",
  },
  th: {
    backgroundColor: "#f2f2f2",
    padding: "8px",
    border: "1px solid black",
  },
  td: {
    padding: "8px",
    border: "1px solid black",
  },
};

export default App;
